var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.629883 26.1229V28.875C0.629883 31.1502 6.17285 33 13.0049 33C19.8369 33 25.3799 31.1502 25.3799 28.875V26.1229C22.718 27.9984 17.8518 28.875 13.0049 28.875C8.15801 28.875 3.2918 27.9984 0.629883 26.1229ZM21.2549 8.25C28.0869 8.25 33.6299 6.4002 33.6299 4.125C33.6299 1.8498 28.0869 0 21.2549 0C14.4229 0 8.87988 1.8498 8.87988 4.125C8.87988 6.4002 14.4229 8.25 21.2549 8.25ZM0.629883 19.3617V22.6875C0.629883 24.9627 6.17285 26.8125 13.0049 26.8125C19.8369 26.8125 25.3799 24.9627 25.3799 22.6875V19.3617C22.718 21.5531 17.8453 22.6875 13.0049 22.6875C8.16445 22.6875 3.2918 21.5531 0.629883 19.3617ZM27.4424 20.0707C31.1355 19.3553 33.6299 18.0275 33.6299 16.5V13.7479C32.1346 14.8049 29.9367 15.5268 27.4424 15.9715V20.0707ZM13.0049 10.3125C6.17285 10.3125 0.629883 12.6199 0.629883 15.4688C0.629883 18.3176 6.17285 20.625 13.0049 20.625C19.8369 20.625 25.3799 18.3176 25.3799 15.4688C25.3799 12.6199 19.8369 10.3125 13.0049 10.3125ZM27.1395 13.9412C31.0066 13.2451 33.6299 11.8787 33.6299 10.3125V7.56035C31.3418 9.17813 27.4102 10.0482 23.2723 10.2545C25.1736 11.1762 26.5723 12.4137 27.1395 13.9412Z",
    fill: "#5F7F04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.629883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/SVG-2.f1ccc15efd7791af4d2598b40af93e45.svg";
export { ForwardRef as ReactComponent };